// メアド自己収集フォーム API クライアント（src/lib/approvalApi.ts と同形）

import { noteAuthRequired } from "./authSignal";

export type RegisterSubmitResult = {
  ok: boolean;
  result?: "sent" | "needsReview" | "error";
  // needsReview のときだけ返る。candidate=同姓同名で絞れない / unmatched=マスターに一致なし
  reason?: "candidate" | "unmatched";
  error?: string;
};

// 公開フォーム：氏名+メアド(+営業所)を送信
export async function registerSubmit(input: {
  name: string;
  email: string;
  branch?: string;
}): Promise<RegisterSubmitResult> {
  try {
    const r = await fetch("/api/register/submit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(input),
    });
    const ct = r.headers.get("content-type") || "";
    if (!ct.includes("application/json")) return { ok: false, error: "API未提供（ローカル環境では動きません）" };
    return (await r.json()) as RegisterSubmitResult;
  } catch (e) {
    return { ok: false, error: e instanceof Error ? e.message : String(e) };
  }
}

// 確認リンク：トークンを確定（正本マスタに email を書き込む）
export async function registerConfirm(
  token: string
): Promise<{ ok: boolean; driverName?: string; alreadyDone?: boolean; error?: string }> {
  try {
    const r = await fetch("/api/register/confirm", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    const ct = r.headers.get("content-type") || "";
    if (!ct.includes("application/json")) return { ok: false, error: "API未提供（ローカル環境）" };
    return (await r.json()) as { ok: boolean; driverName?: string; alreadyDone?: boolean; error?: string };
  } catch (e) {
    return { ok: false, error: e instanceof Error ? e.message : String(e) };
  }
}

export type RegisterReviewItem = {
  id: string;
  inputName: string;
  inputBranch: string;
  email: string;
  reason: "candidate" | "unmatched";
  candidates: { id: string; name: string; branch: string }[];
  createdAt: string;
};

export type RegisterListResult = {
  ok: boolean;
  counts?: {
    active: number;
    registered: number;
    verified: number;
    notSubmitted: number;
    awaitingClick: number;
    reviewQueue: number;
  };
  // contractTo が入っている＝退職予定（終了日までは支払通知が要るので収集対象のまま）
  notSubmitted?: { id: string; name: string; branch: string; contractTo?: string | null }[];
  reviewQueue?: RegisterReviewItem[];
  error?: string;
};

// 事務所：収集状況を取得
export async function fetchRegisterList(): Promise<RegisterListResult> {
  try {
    const r = await fetch("/api/register/list");
    noteAuthRequired(r); // 事務所向け（ログイン必須）。ログイン切れなら AuthGate に知らせる（Astra 補足 2026-09-07）
    const ct = r.headers.get("content-type") || "";
    if (!ct.includes("application/json")) return { ok: false, error: "API未提供（ローカル環境）" };
    return (await r.json()) as RegisterListResult;
  } catch (e) {
    return { ok: false, error: e instanceof Error ? e.message : String(e) };
  }
}
